import classNames from 'classnames';
import { Tooltip } from '@crazyegginc/hatch';
import { formatCurrency } from '/src/utils';

export function DisplayCurrency({
  value,
  precision = 10 ** 4,
  textOnly = false,
  appendCurrency = true,
  trimEmptyCents = false,
  className = '',
  isTruncate = false,
}) {
  if (!value || typeof value.displayWorth !== 'number') return null;

  // TODO: if value.displayCurrency !== value.originalCurrency
  return (
    <Tooltip
      show={value.isConverted}
      tooltipContent={
        <div className="flex flex-col items-center">
          <span>
            <strong>{formatCurrency(value.originalWorth, value.originalCurrency, { precision })}</strong>{' '}
            <span className="text-caption text-mystic-500">{value.originalCurrency}</span>
          </span>
          <span className="text-caption text-mystic-500">Original currency</span>
        </div>
      }
    >
      <div className={classNames('flex', { 'flex-col': !textOnly, 'space-x-1': textOnly, [className]: true })}>
        <span
          className={classNames({
            truncate: isTruncate,
          })}
        >
          {formatCurrency(value.displayWorth, value.displayCurrency, { trimEmptyCents, precision })}
        </span>
        {appendCurrency ? (
          <span className={classNames({ 'text-caption': !textOnly })}>
            {value.displayCurrency}
            {value.isConverted ? '*' : ''}
          </span>
        ) : null}
      </div>
    </Tooltip>
  );
}
